import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

const propTypes = {
  authentication: PropTypes.object,
  logout: PropTypes.func,
  type: PropTypes.string,
};

const defaultProps = {
  type: 'header',
};

const LogoutButton = (props) => {
  const { authentication, type } = props;
  const btnClasses = cx({
    btn: true,
    [`btn--type-${type}`]: type,
    'btn--size-small': true,
    'pull-right': true,
    'page-header__logout': true,
  });
  if (authentication && authentication.isAuthenticated && !authentication.isLoading) {
    return (
      <button
        type="button"
        className={btnClasses}
        onClick={props.logout}
      >
        {COUNTRY !== 'AU'
          && <FormattedMessage id="logout.send" />}
      </button>
    );
  }
  return null;
};

LogoutButton.defaultProps = defaultProps;
LogoutButton.propTypes = propTypes;

export default LogoutButton;
